// Studio — list of all art form modules + passport storage helpers
// Each art form has: id, name, region, blurb, accent color, status (live/coming-soon).

export const ART_FORMS = [
  {
    id: "kolam",
    name: "Kolam",
    region: "Tamil Nadu",
    blurb: "Threshold patterns of dots and curving lines drawn at dawn with rice flour.",
    accent: "#D95D39",
    bg: "#FFF1E5",
    path: "/studio/kolam",
    status: "live",
  },
  {
    id: "warli",
    name: "Warli",
    region: "Maharashtra",
    blurb: "White stick-figure stories of dancers, drummers, and huts painted on mud walls.",
    accent: "#7B3F1D",
    bg: "#F1E4D3",
    path: "/studio/warli",
    status: "live",
  },
  {
    id: "rangoli",
    name: "Rangoli",
    region: "All of India",
    blurb: "Festival floor art made with coloured powder, petals, and rice grains.",
    accent: "#E54B6A",
    bg: "#FFE5EE",
    path: "/studio/rangoli",
    status: "live",
  },
  {
    id: "mandala",
    name: "Mandala",
    region: "Across cultures",
    blurb: "Circles within circles — meditative patterns of symmetry, repetition, and calm.",
    accent: "#6A4FB6",
    bg: "#EFEAFA",
    path: "/studio/mandala",
    status: "live",
  },
];

// ---- Art Passport (localStorage) ----
const PASSPORT_KEY = "meera-studio-passport-v1";

export function getPassport() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(localStorage.getItem(PASSPORT_KEY) || "{}");
  } catch {
    return {};
  }
}

export function stampPassport(artFormId) {
  if (typeof window === "undefined") return;
  const current = getPassport();
  if (!current[artFormId]) {
    current[artFormId] = { stampedAt: new Date().toISOString() };
    try {
      localStorage.setItem(PASSPORT_KEY, JSON.stringify(current));
      window.dispatchEvent(new CustomEvent("passport-update"));
    } catch (err) {
      console.warn("stampPassport: localStorage write failed", err);
    }
  }
}

export function resetPassport() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(PASSPORT_KEY);
    window.dispatchEvent(new CustomEvent("passport-update"));
  } catch (err) {
    console.warn("resetPassport: localStorage clear failed", err);
  }
}
